import { FormatOptions, format, parse } from 'date-fns';
import { isNaN } from 'lodash';
import { Transformer } from '@cp/ds/src/components/form';

/**
 * Configuration options for DateTransformer.
 */
interface DateTransformerOptions {
  dateFormat: string;
  formatOptions?: FormatOptions;
}

export class DateTransformer implements Transformer<string, string> {
  constructor(private options: DateTransformerOptions) {}

  fromControl(value: string = '') {
    if (this.options.dateFormat.length !== value.length) {
      return undefined;
    }
    return parse(value, this.options.dateFormat, new Date()).toISOString();
  }

  toControl(isoStr: string = '') {
    const date = new Date(isoStr);
    if (isNaN(date.getTime())) {
      return undefined;
    }
    return format(date, this.options.dateFormat, this.options.formatOptions);
  }
}
